module.exports = {
    API_URL: process.env.REACT_APP_API_URL,
    ASSET_URL: process.env.REACT_APP_BASE_ASSET_URL + process.env.REACT_APP_ASSET_CONTAINER + process.env.REACT_APP_ASSET_FOLDER,
    TEST_RIDE_CAMPAIGN_ID: process.env.REACT_APP_TEST_RIDE_CAMPAIGN_ID,
    CONTACT_US_CAMPAIGN_ID: process.env.REACT_APP_CONTACT_US_CAMPAIGN_ID,
    VISAKA_SERVICES_API_URL: process.env.REACT_APP_VISAKA_SERVICES_API_URL
  };
